import RequestManager from '../requests/RequestManager';
import PinStatusWithTimerValidationTask from "src/requests/tasks/user/PinStatusWithTimerValidationTask";
import { PinUtil } from '../AAF/Pin/PinUtil'
import channelBlockedUtil from "../utils/ChannelBlockedUtil";

class BlockedChannels {
    constructor() {
        this.data = [];
        this.checkBlockedChannels = this.checkBlockedChannels.bind(this);
        this.channelsRequest = new PinStatusWithTimerValidationTask();
        this.blockedChannels = []
    }

    checkBlockedChannels() {
        return new Promise((resolve, reject) => {
            RequestManager.addRequest(this.channelsRequest).then((resp) => {
                if(!resp.response.errors){
                    PinUtil.handleDataPinCodesSuccess(resp, this.blockedChannels)
                    resolve(this.blockedChannels);
                }
            }).catch((err) => {
                console.error(err);
                PinUtil.handleDataPinCodesError(this.blockedChannels)
                reject(err);
            });
        });

    }
}

export default BlockedChannels;



// WEBPACK FOOTER //
// ./src/utils/BlockedChannels.js